export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_KEY || '';
